/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateScholarshipFilesDeadlineRequestViewModel } from "../types/UpdateScholarshipFilesDeadlineRequestViewModel.ts";

export const updateScholarshipFilesDeadlineRequestViewModelSchema = z.object({
  deadline: z
    .string()
    .datetime()
    .describe(
      "Nova data de prorrogação para entrega dos documentos. Gravada na matrícula do aluno, então vale para todos os planos dela. Obrigatória.",
    )
    .nullish(),
}) as unknown as ToZod<UpdateScholarshipFilesDeadlineRequestViewModel>;
